import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const generateCodeData = params =>
  axios.post(`${API_HOST}/gen/code`, params, { withCredentials: true });

export const test = id =>
  axios.get(`${API_HOST}/gen/code/${id}`, { withCredentials: true });
